import { render, staticRenderFns } from "./warehouseVetPrescriptionCard.vue?vue&type=template&id=976b6678&"
import script from "./warehouseVetPrescriptionCard.vue?vue&type=script&lang=js&"
export * from "./warehouseVetPrescriptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports